import React, {useState, useEffect} from 'react';
import Image from 'next/image';
import styles from '../../styles/layout/navigation.module.scss';

export default function Navigation({variant = 'dark', className = ''}) {

    const [isSticky, setIsSticky] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsSticky(window.scrollY > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (<header
            className={`${styles.header} ${isSticky ? styles.sticky : ''} ${variant === 'light' ? styles.light : ''} ${className}`}
        >
        <div className={styles.container}>
            <div className={styles.logoNav}>
                {/* Logo */}
                <a href={'/'} style={{textDecoration: 'none'}}>
                    <div className={styles.logo}>
                        <svg width="146" height="25" viewBox="0 0 146 25" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0_1311_395)">
                                <path
                                    d="M75.1551 2.31252H79.5612V24.5H75.1551V16.9783H64.9269V24.5H60.5523V2.31252H64.9269V13.1073H75.1551V2.31252ZM100.867 6.215H88.5306V14.1144H99.1365V18.0168H88.5306V24.5H84.156V2.31252H100.867V6.215ZM124.178 13.422C124.178 19.3072 119.552 24.5 113.73 24.5H104.225V2.31252H113.006C119.174 2.31252 124.178 7.28503 124.178 13.422ZM108.6 20.3772H113.352C116.877 20.3772 119.741 17.1356 119.741 13.422C119.741 9.58246 116.72 6.4353 113.006 6.4353H108.6V20.3772ZM135.265 9.8657L140.741 2.31252H145.745L138.192 13.2961L145.965 24.5H140.835L135.265 16.758L129.694 24.5H124.564L132.369 13.2961L124.785 2.31252H129.82L135.265 9.8657Z"
                                    fill="#060606"/>
                                <path
                                    d="M49.0965 0.270016C49.9572 0.271354 49.9168 0.257518 50.5652 0.298336C51.5786 0.362256 52.3424 1.78595 51.5252 2.59716C51.1172 3.00211 50.9957 3.10122 50.5799 3.49365C49.6767 4.34632 48.535 5.49519 47.1355 6.7417C46.6407 7.19441 46.1451 7.64737 45.6502 8.10009C44.0543 9.56046 44.5437 9.50783 42.4051 9.50146L31.2098 9.46826C31.2024 9.46843 31.1948 9.47004 31.1873 9.47021C30.847 9.4776 30.1893 9.409 30.6746 9.8833C34.0309 12.8993 37.3295 15.8629 41.0799 19.2329C41.5956 19.6961 43.0303 21.1707 44.2019 22.2446C44.9164 22.8995 45.6904 24.5531 43.2762 25.1636L32.3767 25.1733C29.25 22.3416 26.1227 19.51 22.9959 16.6782C22.9951 16.6774 22.9937 16.6771 22.993 16.6763C22.9874 16.6703 22.981 16.6653 22.9754 16.6597C22.9475 16.6344 22.9192 16.6097 22.8914 16.5845C22.4704 16.2515 22.0409 16.5692 21.8299 16.7241V16.7231C19.2197 19.067 16.6099 21.4115 13.9998 23.7554C12.0397 25.5163 12.4163 25.0958 9.74784 25.1108C7.43265 25.1239 5.22998 25.1503 2.77323 25.147C1.91262 25.1456 1.95302 25.1595 1.30448 25.1186C0.291232 25.0547 -0.472444 23.632 0.344518 22.8208C0.752666 22.4157 0.874187 22.3165 1.28983 21.9243C2.19308 21.0716 3.33559 19.9219 4.73514 18.6753C5.23 18.2226 5.72564 17.7696 6.22049 17.3169C7.81621 15.8566 7.32656 15.9092 9.46561 15.9155L21.1394 15.9478C22.2094 15.9662 21.8166 15.6094 21.6355 15.4458C17.7033 11.8846 13.7708 8.32337 9.83866 4.7622C7.15781 2.85667 8.28252 0.928303 9.76639 0.98486C12.9642 0.981513 15.5949 0.97844 18.7928 0.975094C20.7521 0.972417 21.0602 1.24406 22.5496 2.58252C24.7042 4.51873 26.71 6.32081 28.6629 8.07568C28.6776 8.08663 28.6961 8.10231 28.7176 8.12451C28.9101 8.29749 29.1021 8.46992 29.2937 8.64209C29.5884 8.82777 29.852 8.8125 30.2234 8.52685C32.772 6.23822 35.3213 3.95019 37.8699 1.66162C39.8299 -0.0992989 39.4536 0.321172 42.1219 0.306149C44.437 0.293097 46.6398 0.26667 49.0965 0.270016Z"
                                    fill="#060606"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_1311_395">
                                    <rect width="146" height="25" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                </a>

                {/* Navigation Links */}
                <div className={`${styles.navWrapper} ${isMenuOpen ? styles.open : ''}`}>
                    <svg
                        className={styles.mobileLogo}
                        width="900" height="209" viewBox="0 0 900 209" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M461.353 30.798H488.4V167H461.353V120.827H398.564V167H371.71V30.798H398.564V97.0636H461.353V30.798ZM619.192 54.7541H543.46V103.246H608.567V127.202H543.46V167H516.606V30.798H619.192V54.7541ZM762.291 98.9956C762.291 135.123 733.891 167 698.15 167H639.805V30.798H693.707C731.573 30.798 762.291 61.3227 762.291 98.9956ZM666.659 141.692H695.832C717.469 141.692 735.05 121.793 735.05 98.9956C735.05 75.4259 716.503 56.1064 693.707 56.1064H666.659V141.692ZM830.346 77.1646L863.962 30.798H894.68L848.313 98.2228L896.032 167H864.542L830.346 119.474L796.151 167H764.66L812.572 98.2228L766.013 30.798H796.924L830.346 77.1646Z"
                            fill="white"/>
                        <path
                            d="M301.391 17.0055C306.674 17.0137 306.426 16.9248 310.407 17.1754C316.628 17.5681 321.318 26.306 316.301 31.2858C313.795 33.7734 313.049 34.38 310.495 36.7897C304.951 42.0242 297.941 49.0767 289.35 56.7291C286.311 59.5087 283.271 62.2904 280.233 65.0699C270.435 74.0353 273.442 73.7086 260.311 73.6696L191.291 73.4781C189.185 73.5021 185.464 73.1869 188.219 75.941C208.851 94.4809 229.122 112.697 252.175 133.413C255.341 136.256 264.153 145.306 271.345 151.898C275.731 155.919 280.479 166.069 265.657 169.816L198.749 169.878C179.616 152.55 160.482 135.222 141.349 117.894C141.286 117.846 141.224 117.79 141.162 117.725C140.931 117.516 140.7 117.307 140.469 117.097C137.904 115.131 135.292 117.066 134.007 118.009V118.008C117.985 132.396 101.963 146.787 85.9406 161.174C73.9081 171.985 76.2212 169.397 59.84 169.49C45.6278 169.57 32.1076 169.733 17.0265 169.713C11.7427 169.704 11.991 169.792 8.00989 169.542C1.78927 169.149 -2.90126 160.412 2.11536 155.432C4.6217 152.944 5.36743 152.338 7.92102 149.928C13.4658 144.694 20.4761 137.641 29.0675 129.989C32.1059 127.209 35.1463 124.428 38.1847 121.648C47.9818 112.683 44.9741 113.009 58.1056 113.048L130.493 113.247C136 113.192 134.007 111.247 132.909 110.251C108.738 88.3606 84.5671 66.4707 60.3966 44.5807C43.9392 32.8832 50.8433 21.0424 59.9523 21.3893C79.5839 21.3687 95.7338 21.3503 115.365 21.3297C127.394 21.3133 129.284 22.9813 138.428 31.1989C151.646 43.0773 163.95 54.1328 175.931 64.899C176.029 64.9685 176.155 65.0785 176.307 65.2369C177.487 66.2978 178.665 67.3559 179.84 68.4117C181.631 69.5334 183.246 69.4462 185.496 67.7301C201.156 53.6679 216.816 39.6055 232.476 25.5436C244.508 14.7334 242.196 17.3196 258.577 17.2272C272.789 17.1471 286.31 16.9849 301.391 17.0055Z"
                            fill="white"/>
                    </svg>
                    <svg
                        onClick={() => {
                            setIsMenuOpen(!isMenuOpen)
                        }}
                        className={styles.closeIcon} xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                        viewBox="0 0 24 24" fill="none">
                        <path d="M3 3L21 21" stroke="#fff" strokeWidth="2.4" strokeLinecap="round"
                              strokeLinejoin="round"/>
                        <path d="M3 21L21 3" stroke="#fff" strokeWidth="2.4" strokeLinecap="round"
                              strokeLinejoin="round"/>
                    </svg>
                    <nav className={styles.navLinks}>
                        <a
                            onClick={() => {
                                setIsMenuOpen(false)
                            }}
                            href={process.env.NEXT_PUBLIC_TRADE_URL} target={'_blank'} rel={'noreferrer'} className={`${styles.navLink} ${styles.active}`}>
                            <span>Trade</span>
                        </a>
                        <a
                            onClick={() => {
                                setIsMenuOpen(false)
                            }}
                            href="/invest" className={styles.navLink}>
                            <span>Invest</span>
                            <span className={styles.aprBadge}>
                APR 30%
                <Image
                    src="/images/hero/graph-stats.svg"
                    alt="APR growth chart"
                    width={16}
                    height={16}
                />
              </span>
                        </a>
                        <div className={styles.navDropdown}>
                            <span className={styles.navLink}>
                                <span>Learn</span>
                                <svg className={styles.dropdownArrow} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </span>
                            <div className={styles.dropdownMenu}>
                                <a
                                    onClick={() => {
                                        setIsMenuOpen(false)
                                    }}
                                    href="/faqs" className={styles.dropdownItem}>
                                    FAQs
                                </a>
                                <a
                                    onClick={() => {
                                        setIsMenuOpen(false)
                                    }}
                                    href="/docs" className={styles.dropdownItem}>
                                    Docs
                                </a>
                                <a
                                    onClick={() => {
                                        setIsMenuOpen(false)
                                    }}
                                    href="/blog" className={styles.dropdownItem}>
                                    Blog
                                </a>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>

            {/* Auth Buttons */}
            <div className={styles.authButtons}>
                <a href={process.env.NEXT_PUBLIC_APP_URL + '/sign-in'} className={styles.loginBtn}>
                    <span>Login</span>

                  <Image
                      className={styles.btnIcon}
                      src="/images/hero/login-icon.svg"
                      alt="Login"
                      width={40}
                      height={40}
                  />

                </a>
                <a href={process.env.NEXT_PUBLIC_APP_URL + '/sign-up'} className={styles.signUpBtn}>
                    <span>Sign Up</span>

                  <Image
                      className={styles.btnIcon}
                      src="/images/hero/group.svg"
                      alt="Sign up"
                      width={32}
                      height={32}
                  />

                </a>
            </div>
            <svg
                className={styles.menuOpen}
                onClick={() => {
                    setIsMenuOpen(!isMenuOpen)
                }}
                xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M9.59998 4.80005H22.8" stroke="black" strokeWidth="2.4" strokeLinecap="round"
                      strokeLinejoin="round"/>
                <path d="M5.40002 12H18.6" stroke="black" strokeWidth="2.4" strokeLinecap="round"
                      strokeLinejoin="round"/>
                <path d="M1.19995 19.2H14.4" stroke="black" strokeWidth="2.4" strokeLinecap="round"
                      strokeLinejoin="round"/>
            </svg>
        </div>
    </header>);
}
